










import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import nutrition from './nutrition.vue'
import food from './food.vue'

@Component({
	components: {nutrition, food}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	 p = this.patient
	position = '营养评估'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/index.vue